import React from 'react';
import { ChartDataItem } from '../types';
import { PieChart } from './charts/PieChart';

interface DashboardOverviewProps {
    expenseData: ChartDataItem[];
    refundData: ChartDataItem[];
    selectedCurrency: string | null;
}

export const DashboardOverview: React.FC<DashboardOverviewProps> = ({
    expenseData,
    refundData,
    selectedCurrency,
}) => {
    return (
        <div className="space-y-8">
            {selectedCurrency ? (
                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h3 className="text-xl font-semibold text-gray-700 mb-4 text-center">Výdaje podle kategorií ({selectedCurrency})</h3>
                        {expenseData.length > 0 ? (
                           <PieChart data={expenseData} currency={selectedCurrency} />
                        ) : (
                            <div className="text-center text-gray-500 py-10">Žádné výdaje pro vybranou měnu.</div>
                        )}
                    </div>
                    {refundData.length > 0 && (
                         <div className="bg-white p-6 rounded-lg shadow">
                            <h3 className="text-xl font-semibold text-gray-700 mb-4 text-center">Vratky podle kategorií ({selectedCurrency})</h3>
                            <PieChart data={refundData} currency={selectedCurrency} />
                        </div>
                    )}
                 </div>
            ) : (
                <div className="text-center text-gray-500 py-10">
                    Vyberte měnu výše pro zobrazení detailů.
                </div>
            )}
        </div>
    );
};